export function buildResearchCoverage(bundle){
  const checks={
    market:bundle?.market?.status||'MISSING',
    companyIdentity:(bundle?.companyFacts?.status==='VERIFIED'||bundle?.alphaCompany?.status==='VERIFIED')?'VERIFIED':'MISSING',
    secFinancials:bundle?.secFinancials?.status||'MISSING',
    companyQualityEvidence:bundle?.companyQualityEvidence?.status||'MISSING',
    dogEvidence:bundle?.dogEvidence?.status||'MISSING',
    stockOpportunityEvidence:bundle?.stockOpportunityEvidence?.status||'MISSING',
    whyWrongEvidence:bundle?.whyWrongEvidence?.status||'MISSING',
    insiderForm4:bundle?.insiderEvidence?.status||'MISSING',
    tenXResearch:bundle?.tenXResearch?.status||'MISSING',
    moatEvidence:bundle?.moatEvidence?.status||'MISSING',
    foxEvidence:bundle?.foxEvidence?.status||'MISSING',
    rocketEvidence:bundle?.rocketEvidence?.status||'MISSING',
    moleEvidence:bundle?.moleEvidence?.status||'MISSING',
    grasshopperEvidence:bundle?.grasshopperEvidence?.status||'MISSING',
    sheepEvidence:bundle?.sheepEvidence?.status||'MISSING',
    consensus:bundle?.consensus?.status||'MISSING',
    grasshopper:bundle?.grasshopper?.verification_status||'MISSING',
    shortInterest:bundle?.shortInterest?.verification_status||'MISSING',
    relationships:Array.isArray(bundle?.relationships)&&bundle.relationships.some(r=>String(r?.verification_status||'').toUpperCase()==='VERIFIED')?'EVIDENCE':'MISSING',
    demand:Array.isArray(bundle?.demand)&&bundle.demand.some(r=>String(r?.verification_status||'').toUpperCase()==='VERIFIED')?'EVIDENCE':'MISSING',
    events:Array.isArray(bundle?.events)&&bundle.events.some(r=>String(r?.verification_status||'').toUpperCase()==='VERIFIED')?'EVIDENCE':'MISSING',
    calendar:Array.isArray(bundle?.calendar)&&bundle.calendar.some(r=>String(r?.verification_status||'').toUpperCase()==='VERIFIED')?'EVIDENCE':'MISSING'
  };
  const values=Object.values(checks);
  const present=values.filter(v=>!['MISSING','REVIEW','ERROR','UNVERIFIED'].includes(String(v).toUpperCase())).length;
  return{
    checks,
    present,
    total:values.length,
    availableCount:present,
    totalCount:values.length,
    completenessPct:Math.round(present/values.length*100),
    missing:Object.entries(checks).filter(([,v])=>['MISSING','REVIEW','ERROR','UNVERIFIED'].includes(String(v).toUpperCase())).map(([k])=>k),
    note:'Coverage describes available evidence only. It is not an investment score.'
  };
}
